import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CustomTopic } from '@data/custom-topic/custom-topic.model';

export interface CustomTopicState
  extends EntityState<CustomTopic, CustomTopic['_id']>, ActiveState<CustomTopic['_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'custom-topics', resettable: true, idKey: '_id' })
export class CustomTopicStore extends EntityStore<CustomTopicState> {
  constructor() {
    super();
  }
}
